var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMission05(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 151,
    viewBox: "0 0 151 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.2103 150.2C116.687 150.2 150.31 116.577 150.31 75.1C150.31 33.6234 116.687 0 75.2103 0C33.7338 0 0.110352 33.6234 0.110352 75.1C0.110352 116.577 33.7338 150.2 75.2103 150.2Z",
    fill: "url(#paint0_linear_339_498)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2101 133.23C107.314 133.23 133.34 107.204 133.34 75.1C133.34 42.9957 107.314 16.97 75.2101 16.97C43.1058 16.97 17.0801 42.9957 17.0801 75.1C17.0801 107.204 43.1058 133.23 75.2101 133.23Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_339_498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.3602 63.7001C69.3302 61.4901 72.1702 60.1901 75.2202 60.1901C78.2702 60.1901 81.1102 61.4901 83.0802 63.7001H86.4802C84.2802 56.7801 80.5002 50.4201 75.3202 45.0601C70.1402 50.4201 66.3602 56.7801 64.1602 63.7001H67.3502H67.3602Z",
    fill: "#F99A22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0201 68C62.2901 71.36 61.9101 74.83 61.9201 78.36C61.9201 81.82 62.3001 85.23 63.0201 88.54H74.7001L66.5501 76.73C64.7701 74.14 64.2501 70.96 65.0401 68.01H63.0201V68Z",
    fill: "#F99A22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7401 78.36C88.7401 74.83 88.3701 71.37 87.6401 68H85.4101C86.2001 70.94 85.6901 74.1 83.9301 76.68L75.8301 88.53H87.6401C88.3601 85.22 88.7301 81.82 88.7401 78.35V78.36Z",
    fill: "#F99A22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3799 74.26C81.7099 72.31 81.8499 69.91 80.7499 67.82C79.6499 65.73 77.5799 64.49 75.2299 64.49C72.8799 64.49 70.7999 65.74 69.6999 67.83C68.5999 69.92 68.7499 72.34 70.0899 74.28L75.2599 81.77L80.3899 74.26H80.3799Z",
    fill: "#F99A22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9704 63.7001H100.92L92.3204 51.2301C91.6004 50.1801 91.0804 49.0301 90.7804 47.8401C87.6204 46.2301 84.2004 45.1301 80.6904 44.5701C84.2904 48.8101 87.1704 53.5601 89.2604 58.7301C89.9204 60.3601 90.4904 62.0101 90.9804 63.6901L90.9704 63.7001Z",
    fill: "#F99A22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.02 56.28L106.15 48.77C107.48 46.82 107.62 44.42 106.52 42.33C105.42 40.24 103.35 39 101 39C98.6505 39 96.5705 40.25 95.4705 42.34C94.3705 44.43 94.5205 46.85 95.8605 48.79L101.03 56.28H101.02Z",
    fill: "#F99A22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.16 63.6999H106.19C105.53 62.3099 104.77 60.9599 103.92 59.6599L101.16 63.6999Z",
    fill: "#F99A22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.68 92.8401H44.46C46.12 96.3401 48.38 99.5701 51.2 102.39C56.36 107.55 62.89 110.85 69.96 111.96C66.4 107.77 63.54 103.08 61.46 97.9701C60.77 96.2801 60.18 94.5701 59.67 92.8301L59.68 92.8401Z",
    fill: "#F99A22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1904 97.9801C87.1104 103.09 84.2604 107.78 80.6904 111.97C87.7704 110.86 94.2904 107.56 99.4504 102.4C102.27 99.5801 104.54 96.3501 106.19 92.8501H90.9704C90.4704 94.5901 89.8704 96.3001 89.1804 97.9901L89.1904 97.9801Z",
    fill: "#F99A22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1699 92.8401C66.3699 99.7601 70.1499 106.13 75.3299 111.49C80.5099 106.13 84.2899 99.7701 86.4899 92.8401H64.1699Z",
    fill: "#F99A22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.88 68H92.0195C92.6995 71.39 93.0395 74.86 93.0295 78.36C93.0295 81.8 92.6795 85.2 92.0195 88.53H107.87C108.9 85.25 109.44 81.8 109.44 78.26C109.44 74.72 108.91 71.27 107.88 67.99V68Z",
    fill: "#F99A22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6197 78.37C57.6197 74.86 57.9597 71.4 58.6297 68.01H52.6197L47.2997 75.8L42.5297 68.86C41.6597 71.9 41.2197 75.05 41.2197 78.27C41.2197 81.81 41.7597 85.26 42.7897 88.54H58.6397C57.9697 85.21 57.6297 81.81 57.6297 78.37H57.6197Z",
    fill: "#F99A22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2902 68.1899L52.4202 60.6799C53.7502 58.7299 53.8902 56.3299 52.7902 54.2399C51.6902 52.1499 49.6202 50.9099 47.2702 50.9099C44.9202 50.9099 42.8302 52.1599 41.7302 54.2499C40.6302 56.3399 40.7802 58.7599 42.1202 60.6999L47.2902 68.1899Z",
    fill: "#F99A22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.97 63.1101L55.56 63.7001H59.68C60.17 62.0301 60.74 60.3701 61.4 58.7401C63.49 53.5701 66.36 48.8201 69.96 44.5801C64.75 45.4101 59.77 47.4501 55.46 50.5301C55.88 51.0501 56.26 51.6201 56.58 52.2301C58.41 55.7001 58.17 59.8701 55.96 63.1001L55.97 63.1101Z",
    fill: "#F99A22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_339_498",
    x1: 18.6704,
    y1: 124.52,
    x2: 130.84,
    y2: 26.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F99A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#F99B24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FBAB4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FCB868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#FEC17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FEC78A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC98F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_339_498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.44,
    height: 72.97,
    fill: "white",
    transform: "translate(41 39)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission05);
export default __webpack_public_path__ + "static/media/Mission-05.ef326024d280fe0f585a151ec92c22f4.svg";
export { ForwardRef as ReactComponent };